import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import Hero from "@/components/sections/Hero";
import LunchSpecial from "@/components/sections/LunchSpecial";
import SocialProof from "@/components/sections/SocialProof";
import SignatureDishes from "@/components/sections/SignatureDishes";
import OrderDelivery from "@/components/sections/OrderDelivery";
import Catering from "@/components/sections/Catering";
import PrivateEvents from "@/components/sections/PrivateEvents";
import BrandStory from "@/components/sections/BrandStory";
import VeganFusion from "@/components/sections/VeganFusion";
import Gallery from "@/components/sections/Gallery";
import CateringForm from "@/components/sections/CateringForm";
import FinalCTA from "@/components/sections/FinalCTA";

export default function Home() {
    return (
        <>
            <Nav />
            <main id="main" data-testid="home-page">
                <Hero />
                <LunchSpecial />
                <SocialProof />
                <SignatureDishes />
                <OrderDelivery />
                <BrandStory />
                <Catering />
                <PrivateEvents />
                <VeganFusion />
                <Gallery />
                <CateringForm />
                <FinalCTA />
            </main>
            <Footer />
            <MobileStickyCTA />
        </>
    );
}
